var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckingColoured = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22557_14631)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22557_14631",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5H34.5V34.5H11.5V11.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22557_14631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2917 22.7532V26.5866C16.2917 27.382 16.9337 28.0241 17.7292 28.0241C18.5246 28.0241 19.1667 27.382 19.1667 26.5866V22.7532C19.1667 21.9578 18.5246 21.3157 17.7292 21.3157C16.9337 21.3157 16.2917 21.9578 16.2917 22.7532ZM22.0417 22.7532V26.5866C22.0417 27.382 22.6837 28.0241 23.4792 28.0241C24.2746 28.0241 24.9167 27.382 24.9167 26.5866V22.7532C24.9167 21.9578 24.2746 21.3157 23.4792 21.3157C22.6837 21.3157 22.0417 21.9578 22.0417 22.7532ZM15.8125 32.8157H31.1458C31.9412 32.8157 32.5833 32.1736 32.5833 31.3782C32.5833 30.5828 31.9412 29.9407 31.1458 29.9407H15.8125C15.0171 29.9407 14.375 30.5828 14.375 31.3782C14.375 32.1736 15.0171 32.8157 15.8125 32.8157ZM27.7917 22.7532V26.5866C27.7917 27.382 28.4337 28.0241 29.2292 28.0241C30.0246 28.0241 30.6667 27.382 30.6667 26.5866V22.7532C30.6667 21.9578 30.0246 21.3157 29.2292 21.3157C28.4337 21.3157 27.7917 21.9578 27.7917 22.7532ZM22.5879 13.1603L15.0171 17.147C14.6242 17.3482 14.375 17.7603 14.375 18.2011C14.375 18.8624 14.9117 19.3991 15.5729 19.3991H31.395C32.0467 19.3991 32.5833 18.8624 32.5833 18.2011C32.5833 17.7603 32.3342 17.3482 31.9412 17.147L24.3704 13.1603C23.8146 12.8632 23.1437 12.8632 22.5879 13.1603Z",
    fill: "#8577E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22557_14631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckingColoured);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checking_coloured.056a533214235cdd462ad9bfa693b083.svg";